import { defineStore } from 'pinia'
import api from './api'

export const useConversionStore = defineStore('conversion', {
  state: () => ({
    currentTask: null,
    history: [],
    settings: {
      max_file_size: 10485760,
      allowedExtensions: 'pdf',
      guestLimit: 3
    },
    loading: false,
    error: null
  }),
  
  actions: {
    async uploadFile(file,option) {
      this.loading = true
      this.error = null
      
      try {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('option',option)
        
        const response = await api.post('/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        
        this.currentTask = {
          id: response.data.task_id,
          filename: response.data.filename,
          status: 'pending'
        }
        
        this.loading = false
        return Promise.resolve(response.data)
      } catch (error) {
        this.loading = false
        this.error = error.response?.data?.message || '上传失败'
        return Promise.reject(error)
      }
    },
    
    async checkStatus(taskId) {
      try {
        const response = await api.get(`/status/${taskId}`)
        
        if (this.currentTask && this.currentTask.id === taskId) {
          this.currentTask.status = response.data.status
          this.currentTask.error = response.data.error
        }
        
        return Promise.resolve(response.data)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    
    async getUserHistory() {
      this.loading = true
      
      try {
        const response = await api.get('/user/history')
        this.history = response.data.history
        this.loading = false
        return Promise.resolve(response.data)
      } catch (error) {
        this.loading = false
        this.error = error.response?.data?.message || '获取历史记录失败'
        return Promise.reject(error)
      }
    },

    async remove(id) {
      this.loading = true
      try {
        const response = await api.get('/user/remove/'+id)
        console.log(222,response);
        this.getUserHistory();

        return Promise.resolve(response.data)
      } catch (error) {
        this.loading = false
        this.error = error.response?.data?.message || '获取历史记录失败'
        return Promise.reject(error)
      }
    },
    
    async getSettings() {
      try {
        const response = await api.get('/settings')
        this.settings = response.data
        console.log('settings',this.settings);
        return Promise.resolve(response.data)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    
    clearCurrentTask() {
      this.currentTask = null
    }
  }
})